import { UIDataAdapter } from '../ui/component/adapter';
import { UIList } from '../ui/component/list';
import { $el } from '../ui/elements';
import { UIValue } from '../ui/types';
import { yDefaultPreventer } from '../y/util';

interface EDFieldsDelegate {
    insertField(field: UIValue<string>): void;
}

export class EDFields extends UIList {
    adapter: UIDataAdapter<UIValue<string>, HTMLSpanElement>;
    private _current?: EDFieldsDelegate;

    constructor(fields: UIValue<string>[]) {
        const adapter = new UIDataAdapter((f: UIValue<string>) => {
            const span = $el.SPAN('ed-field-tag', `\u00a0\u00a0\u00a0${f.name}\u00a0\u00a0\u00a0`);
            span.addEventListener('click', () => {
                if(this._current) {
                    this._current.insertField(f);
                }
            });
            return span;
        }, fields);

        super(adapter, { classes: 'ed-fields' });

        this.adapter = adapter;
        this.ui_hide();

        this.root.addEventListener('mousedown', yDefaultPreventer);
    }

    onFocus(editable: EDFieldsDelegate) {
        this._current = editable;
        this.ui_show();
    }

    onBlur(editable: EDFieldsDelegate) {
        if(this._current == editable) {
            this._current = undefined;
            this.ui_hide();
        }
    }

    fixFields(elem: HTMLElement) {
        const inputs = elem.querySelectorAll('input[data-field]');
        for(let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            const slug = input.getAttribute('data-field');
            if(!slug) return;
            const field = this.adapter.data.find(f => f.key == slug);
            if(!field) return;
            if(field.name !== input.getAttribute('value'))
                input.setAttribute('value', field.name);
        }
    }
}
